export default __webpack_public_path__ + "static/glass-5-3bc0c556cdeb765a7f30cb559201fc7c.jpg";